<template>
  <div class="components-panel">
    <div v-if="!isSingleMode" class="components-panel-header" @click="toggleDropdown">
      <span>添加图表</span>
      <i class="el-icon-arrow-down" :class="{ 'is-expanded': isDropdownOpen }"></i>
    </div>
    <!-- 悬浮下拉容器 -->
    <div class="dropdown-overlay" v-if="isDropdownOpen">
      <div class="dropdown-container">
        <c-tabs style="background-color: #fff;" :tabList="tabList" v-model="activeTab"
          @change="handleTabChange(activeTab, true)" />
        <div class="components-widgets">
          <div class="jzliu-cli-bi-engine-components-panel-query">
            <el-select :popper-append-to-body="false" @change="handleTabChange(activeTab)" size="mini"
              v-model="queryList.classify" placeholder="请选择">
              <el-option v-for="i in classifyListView" :key="i.value" :label="i.label" :value="i.value"></el-option>
            </el-select>
            <el-input @keyup.enter="handleTabChange(activeTab)" @change="handleTabChange(activeTab)" size="mini"
              v-model="queryList.search" placeholder="请输入指标名称" />
            <el-popover ref="filterPopover" placement="bottom-end" width="400" trigger="click"
              v-model="filterPopoverVisible" popper-class="jzliu-bi-filter-popover" @show="openFilterPopover">
              <div class="jzliu-bi-filter-popover-content">
                <div class="jzliu-bi-filter-category" v-for="category in filterCategories" :key="category.key">
                  <div class="jzliu-bi-filter-category-label">{{ category.label }}</div>
                  <div class="jzliu-bi-filter-options">
                    <el-checkbox v-for="option in category.options" :key="option.value"
                      :value="isFilterOptionActive(category.key, option.value)"
                      :indeterminate="option.value === 'all' && isFilterIndeterminate(category.key)"
                      @change="(checked) => handleCheckboxChange(category.key, option.value, checked, category)"
                      class="jzliu-bi-filter-checkbox">
                      {{ option.label }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
              <div class="jzliu-bi-filter-popover-footer">
                <el-button size="small" @click="resetFilters">重置</el-button>
                <el-button type="primary" size="small" @click="applyFilters">确定</el-button>
              </div>
              <el-badge slot="reference" :value="activeFilterCount" :hidden="activeFilterCount === 0" :max="99">
                <img class="jzliu-cli-bi-engine-components-panel-query-img" width="16" height="16"
                  src="@/assets/img/filter.png" alt="filter" :class="{ 'is-active': hasActiveFilters }">
              </el-badge>
            </el-popover>
          </div>
          <div v-if="!localWidgets.length"
            style="display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;margin-top: 100px;">
            <img width="50%" src="@/assets/img/empty.png" alt="empty" class="empty-img"></img>
            <div style="font-size: 14px;color: #999;">暂无数据</div>
          </div>
          <div style="background-color: #fff;padding:12px 16px;margin-bottom: 12px;" v-for="i in localWidgets"
            :key="`${activeTab}_${i._wid}`">
            <div class="components-item-warp" @click="clickToAdd(i)" @drag="drag(i)" @dragend="dragend(i)"
              draggable="true" unselectable="on">
              <div style="display: flex;align-items: center">
                <div class="indicator-title" :title="i.dataSetName">{{ i.dataSetName }}</div>
                <el-tooltip :content="getAuditStatus(i)" placement="top" effect="dark">
                  <div class="jzliu-cli-bi-engine-components-panel-status"
                    :style="{ backgroundColor: getAuditBgColor(i), color: getAuditColor(i) }">{{ getAuditStatus(i) }}</div>
                </el-tooltip>
              </div>
              <div :class="['jzliu-cli-bi-engine-components-panel-query-img-icon', bgImgClass(i)]"></div>
              <!-- <chart-render :chartConfigHandler="chartConfigHandler" :chartData="i"></chart-render> -->
            </div>
          </div>
          <!-- <div v-for="i in list" :key="i.className">
            <div class="indicator-title">{{ i.name }}</div>
            <div class="components-item" @drag="drag(i)" @dragend="dragend(i)" draggable="true" unselectable="on">
              <el-tooltip :content="i.name" placement="top" effect="dark">
                <div :class="i.className"></div>
              </el-tooltip>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { panelMap } from '../utils/panelConf'
import { widgets } from '../mock/charts'
import chartRender from './charts/chartRender'
import cTabs from './base/cTabs'
import { updatePanelWidget } from '../utils/index'
import { widgetTypeMap, AuditStatusConfMap,AuditStatusMap,UseTypeMap } from '@/utils/enum.data'
export default {
  name: 'componentsPanel',
  components: {
    chartRender,
    cTabs,
  },
  props: {
    // 从外部传入的 widgets 数据
    mode: {
      type: String,
      default: '',
    },
    widgets: {
      type: Array,
      default: () => []
    },
    classifyList: {
      type: Array,
      default: () => []
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
  },
  computed: {
    classifyListView() {
      console.log('classifyList:', this.classifyList)
      return this.classifyList;
    },
    isSingleMode() {
      return this.mode === 'single'
    },
    filterCategories() {
      // 固定的筛选分类
      return [
        {
          key: 'status',
          label: '状态',
          options: [
            { label: '可用', value: 'available' },
            { label: '不可用', value: 'unavailable' }
          ]
        },
        {
          key: 'useType',
          label: '使用方式',
          options: [
            { label: '仅展示在线查询', value: UseTypeMap.query }
          ]
        }
      ]
    },
    hasActiveFilters() {
      // 检查是否有激活的筛选条件（使用已生效的 filterValues）
      const filterValues = this.queryList.filterValues || {}
      return Object.keys(filterValues).some(key => {
        const values = filterValues[key]
        return values && values.length > 0 && !values.includes('all')
      })
    },
    activeFilterCount() {
      // 计算当前选中的筛选条件数量（排除"全部"），使用已生效的 filterValues
      const filterValues = this.queryList.filterValues || {}
      let count = 0

      Object.keys(filterValues).forEach(key => {
        const values = filterValues[key] || []
        // 排除"全部"选项，计算实际选中的数量
        const activeValues = values.filter(v => v !== 'all')
        count += activeValues.length
      })

      return count
    }
  },
  data() {
    return {
      list: [],
      tabList: [
        { key: 'all', label: '全部图表' },
        { key: 'my', label: '我收藏的' },
      ],
      // 使用 props 中的 widgets，如果没有传入则使用默认的
      localWidgets: this.widgets.length > 0 ? this.widgets : [],
      isUpdateWidget: false,
      isDropdownOpen: false,
      activeTab: 'all',
      queryList: {
        classify: '',
        search: '',
        filterValues: {} // 存储筛选值 { categoryKey: [value1, value2, ...] }
      },
      isDragging: false, // 标记是否正在拖拽
      currentDragId: null, // 当前拖拽的图表 ID
      filterPopoverVisible: false,
      tempFilterValues: {}, // 临时筛选值，用于弹窗中的操作
    }
  },
  watch: {
    // 监听外部传入的 widgets 变化
    widgets: {
      handler(newWidgets) {
        if (newWidgets && newWidgets.length > 0) {
          this.localWidgets = newWidgets
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    for (let i in panelMap) {
      this.list.push({
        type: i,
        ...panelMap[i],
      })
    }
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick)
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleGlobalClick)
  },
  methods: {
    getAuditStatus(panel) {
      console.log('panel.auditStatus:', panel.auditStatus)
      return AuditStatusConfMap[panel.auditStatus]?.text
    },
    getAuditBgColor(panel) {
      return AuditStatusConfMap[panel.auditStatus]?.bgColor
    },
    getAuditColor(panel) {
      return AuditStatusConfMap[panel.auditStatus]?.color
    },
    bgImgClass(panel) {
      return panel.type === widgetTypeMap.Table ? 'component-type-cross-table' : panel.type === widgetTypeMap.Column ? 'component-type-bar' : panel.type === widgetTypeMap.Pie ? 'component-type-pie' : panel.type === widgetTypeMap.Line ? 'component-type-line' : panel.type === widgetTypeMap.IndicatorCard ? 'component-type-indicator-card' : panel.type === widgetTypeMap.Gauge ? 'component-type-gauge' : ''
    },
    handleTabChange(tabKey, isClear = false) {
      if (isClear) {
        this.$set(this.queryList, 'search', '')
        this.$set(this.queryList, 'classify', '')
      }
      this.activeTab = tabKey
      this.$emit('tab-change', {
        tabKey: tabKey,
        queryList: this.queryList,
        tabLabel: this.tabList.find(tab => tab.key === tabKey)?.label || tabKey
      })
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
      if (this.isDropdownOpen && !this.isUpdateWidget) {
        this.isUpdateWidget = true
        this.localWidgets.forEach(item => {
          updatePanelWidget(item)
        })
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    handleGlobalClick(event) {
      // 检查点击是否在组件内部
      if (!this.$el.contains(event.target)) {
        this.closeDropdown()
      }
    },
    clickToAdd(panel) {
      // 如果正在拖拽，不触发点击添加
      if (this.isDragging) {
        this.isDragging = false
        return
      }
      if (!this.canAdd(panel)) return
      // 深拷贝 panel 并强制生成新的唯一 ID（每次点击都生成新 ID）
      const panelCopy = JSON.parse(JSON.stringify(panel))
      panelCopy._id = `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`

      // 发射点击添加事件
      this.$emit('click-add', panelCopy)

    },
    drag(panel) {
      // 标记正在拖拽
      this.isDragging = true

      // 深拷贝 panel，避免污染原始数据
      const panelCopy = JSON.parse(JSON.stringify(panel))

      // 在拖拽开始时生成唯一 ID 并保存
      if (!this.currentDragId) {
        this.currentDragId = `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
      }
      panelCopy._id = this.currentDragId

      this.$emit('drag', panelCopy)
    },
    canAdd(panel) {
      if (![AuditStatusMap.APPLY].includes(panel.auditStatus) && panel.useType?.includes(UseTypeMap.query)) {
        this.$message.error('请申请此数据的使用权限，且使用方式包含在线查询，才可正常搭建看板')
        return false
      }
      return true
    },
    dragend(panel) {
      if (!this.canAdd(panel)) return
      // 深拷贝 panel，避免污染原始数据
      const panelCopy = JSON.parse(JSON.stringify(panel))

      // 使用拖拽过程中保存的 ID（确保与 drag 事件中的 ID 一致）
      if (!this.currentDragId) {
        this.currentDragId = `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
      }
      panelCopy._id = this.currentDragId

      // panel.dataSetId = ''
      // panel.data = null
      // panel['fields'].forEach((v) => {
      //   this.$set(v, 'chooseFields', [])
      // })
      this.$emit('dragend', panelCopy)

      // 拖拽结束后自动收起下拉容器
      // this.closeDropdown()

      // 延迟重置拖拽标记和 ID，避免拖拽后立即触发点击
      setTimeout(() => {
        this.isDragging = false
        this.currentDragId = null  // 清空当前拖拽 ID，为下次拖拽准备
      }, 100)
    },
    // 打开筛选弹窗时，初始化临时筛选值
    openFilterPopover() {
      // 深拷贝当前的筛选值到临时变量
      this.tempFilterValues = JSON.parse(JSON.stringify(this.queryList.filterValues || {}))
      this.filterPopoverVisible = true
    },
    // 判断"全部"是否应该显示为半选状态
    isFilterIndeterminate(categoryKey) {
      const filterValues = this.tempFilterValues || {}
      const values = filterValues[categoryKey] || []

      // 如果包含"全部"，不是半选状态
      if (values.includes('all')) {
        return false
      }

      // 获取该分类的所有选项（排除"全部"）
      const category = this.filterCategories.find(cat => cat.key === categoryKey)
      if (!category) return false

      const otherOptions = category.options.filter(opt => opt.value !== 'all')
      const selectedCount = values.length
      const totalCount = otherOptions.length

      // 如果部分选中（不是0也不是全部），返回true
      return selectedCount > 0 && selectedCount < totalCount
    },
    // 处理 checkbox 变化
    handleCheckboxChange(categoryKey, optionValue, checked, category) {
      if (!this.tempFilterValues[categoryKey]) {
        this.$set(this.tempFilterValues, categoryKey, [])
      }

      const values = this.tempFilterValues[categoryKey]

      if (optionValue === 'all') {
        // 如果点击"全部"
        if (checked) {
          // 选中"全部"，选中该分类下的所有其他选项
          const otherOptions = category.options.filter(opt => opt.value !== 'all').map(opt => opt.value)
          this.$set(this.tempFilterValues, categoryKey, ['all', ...otherOptions])
        } else {
          // 取消"全部"，清空所有选项
          this.$set(this.tempFilterValues, categoryKey, [])
        }
      } else {
        // 移除"全部"选项（如果存在）
        const allIndex = values.indexOf('all')
        if (allIndex > -1) {
          values.splice(allIndex, 1)
        }

        // 切换当前选项
        const index = values.indexOf(optionValue)
        if (checked) {
          // 选中
          if (index === -1) {
            values.push(optionValue)
          }
        } else {
          // 取消选中
          if (index > -1) {
            values.splice(index, 1)
          }
        }

        // 获取该分类的所有其他选项
        const otherOptions = category.options.filter(opt => opt.value !== 'all').map(opt => opt.value)
        const selectedOtherOptions = values.filter(v => v !== 'all')

        // 如果所有其他选项都选中了，自动选中"全部"
        if (selectedOtherOptions.length === otherOptions.length && otherOptions.length > 0) {
          values.push('all')
        }

        // 如果没有任何选项，不添加"全部"（保持空数组）
      }
    },
    // 检查筛选选项是否激活（使用临时值）
    isFilterOptionActive(categoryKey, optionValue) {
      const filterValues = this.tempFilterValues || {}
      const values = filterValues[categoryKey] || []
      return values.includes(optionValue)
    },
    // 重置筛选
    resetFilters() {
      // 重置临时值
      this.tempFilterValues = {}
      // 应用到实际的筛选值
      this.$set(this.queryList, 'filterValues', {})
      this.filterPopoverVisible = false
      // 触发筛选更新
      this.$emit('filter-change', this.queryList.filterValues)
      this.handleTabChange(this.activeTab)
    },
    // 应用筛选
    applyFilters() {
      // 将临时值应用到实际的筛选值
      this.$set(this.queryList, 'filterValues', JSON.parse(JSON.stringify(this.tempFilterValues)))
      console.log('this.queryList:', this.queryList.filterValues)
      this.filterPopoverVisible = false
      // 触发筛选更新
      this.$emit('filter-change', this.queryList.filterValues)
      this.handleTabChange(this.activeTab)
    },
  },
}
</script>

<style scoped lang="less">
.indicator-title {
  color: var(--bi-jz-font-color);
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jzliu-cli-bi-engine-components-panel-query {
  margin: 12px 16px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .el-select {
    position: relative;

    /deep/ .el-input__inner {
      background-color: var(--bi-jz-input-bg-color);
      border: 1px solid var(--bi-jz-border-color);
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      color: var(--bi-jz-font-color);

      &::placeholder {
        color: rgba(255, 255, 255, 0.6);
      }

      &:focus {
        border-color: #2e74ff;
        background-color: rgba(255, 255, 255, 0.15);
        border-right: none;
      }
    }

    /deep/ .el-input__suffix {
      .el-input__suffix-inner {
        .el-input__icon {
          color: var(--bi-jz-font-color);
        }
      }
    }

    // 添加连接处的边框
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: var(--bi-jz-border-color);
      z-index: 1;
    }

    &:focus-within::after {
      background-color: #2e74ff;
    }
  }

  .el-input {
    /deep/ .el-input__inner {
      background-color: var(--bi-jz-input-bg-color);
      border: 1px solid var(--bi-jz-border-color);
      border-left: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      color: var(--bi-jz-font-color);

      &::placeholder {
        color: rgba(255, 255, 255, 0.6);
      }

      &:focus {
        border-color: #2e74ff;
        background-color: rgba(255, 255, 255, 0.15);
        border-left: none;
      }
    }
  }
}

.components-panel {
  flex: 1;
  display: flex;
  align-items: center;
  background: var(--bi-jz-bg-color);
  height: 48px;
  border-right: 1px solid var(--bi-jz-border-color);
  width: 100%;
  position: relative;

  .components-panel-header {
    display: flex;
    width: 200px;
    align-items: center;
    height: 100%;
    padding: 0 16px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    i:first-child {
      margin-right: 8px;
      color: var(--bi-jz-font-color);
    }

    span {
      flex: 1;
      color: var(--bi-jz-font-color);
      font-size: 14px;
    }

    .el-icon-arrow-down {
      color: var(--bi-jz-font-color);
      transition: transform 0.3s ease;

      &.is-expanded {
        transform: rotate(180deg);
      }
    }
  }

  // 悬浮下拉容器
  .dropdown-overlay {
    position: fixed;
    top: 96px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    width: 244px;
    height: calc(100% - 100px);
    background: rgba(0, 0, 0, 0.3);

    .dropdown-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      border: 1px solid var(--bi-jz-border-color);
      border-radius: 0 0 4px 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      z-index: 99;
      overflow-y: auto;
      animation: slideDown 0.3s ease;

      .components-widgets {
        display: block;
        width: 100%;

        .components-item-warp {
          width: 100%;
          height: 30px;
          line-height: 30px;
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;

          // 添加点击提示
          &::after {
            content: '点击添加 / 拖拽放置';
            position: absolute;
            bottom: 8px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            opacity: 0;
            transition: opacity 0.2s ease;
            pointer-events: none;
            white-space: nowrap;
          }

          // &:hover {
          //   background: rgba(255, 255, 255, 1);
          //   border-color: #2e74ff;
          //   transform: translateY(-2px);
          //   box-shadow: 0 4px 12px rgba(46, 116, 255, 0.2);

          //   &::after {
          //     opacity: 1;
          //   }
          // }

          // &:active {
          //   cursor: grabbing;
          // }

        }
      }
    }
  }

  .guid-tip-container {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 1.5;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.jzliu-cli-bi-engine-components-panel-query-img {
  margin-left: 6px;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  &.is-active {
    opacity: 1;
    filter: brightness(1.2);
  }
}

// Badge 样式
.jzliu-cli-bi-engine-components-panel-query {
  :deep(.el-badge) {
    margin-left: 6px;

    .el-badge__content {
      border: none;
      font-size: 10px;
      height: 16px;
      line-height: 16px;
      min-width: 16px;
      padding: 0 4px;
    }
  }
}
</style>

<style lang="less">
// 筛选弹窗样式
.jzliu-bi-filter-popover {
  padding: 0;

  .jzliu-bi-filter-popover-content {
    padding: 16px;
    max-height: 400px;
    overflow-y: auto;
  }

  .jzliu-bi-filter-category {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .jzliu-bi-filter-category-label {
      font-size: 14px;
      font-weight: 500;
      color: #1D2129;
      margin-bottom: 12px;
      padding-left: 4px;
    }

    .jzliu-bi-filter-options {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      .jzliu-bi-filter-checkbox {
        margin: 0;
        font-size: 12px;
        color: #4E5969;
        font-weight: 400;

        :deep(.el-checkbox__label) {
          font-size: 12px;
          color: #4E5969;
          padding-left: 8px;
        }

        :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
          background-color: #165DFF;
          border-color: #165DFF;
        }

        :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
          color: #165DFF;
        }
      }
    }
  }

  .jzliu-bi-filter-popover-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid #EDEFF2;
    gap: 8px;

    .el-button {
      padding: 5px 12px;
      height: 28px;
      font-size: 12px;
    }
  }
}

.jzliu-cli-bi-engine-components-panel-query-img-icon {
  width: 70px;
  height: 70px;
  display: block;
  position: relative;
  left: 42px;
  top: 20px;
  background-image: url('~@/assets/img/panel.png');
  background-repeat: no-repeat;
  -webkit-transform: scale(.5);
  transform: scale(.5);
  transform-origin: left top;
  cursor: pointer;
}

.jzliu-cli-bi-engine-components-panel-status {
  margin-left: 10px;
  padding: 0 2px;
}
</style>
